// @flow
import React, { Component } from "react";
import Measure from "react-measure";
import SlidersIcon from "react-feather/dist/icons/sliders";
import CloseIcon from "react-feather/dist/icons/x";
import Slider from "rc-slider";
import "rc-slider/assets/index.css";

import styles from "./FilterBar.module.css";
import container from "../../../styles/container.module.css";
import ServerityLabel from "../../shared/SeverityRating/Label/Label";

type Props = {
  selectedVector: string,
  severity: number
};

type State = {
  modalOpen?: boolean,
  selectedVector: string,
  severity?: number,
  dimensions?: {
    left: number,
    top: number
  }
};

const FilterBarModal = ({
  style,
  open,
  attackVectors,
  toggleAttackVector,
  toggleModal,
  selectedVector,
  updateFilterModal,
  onSliderChange,
  clearFilters,
  severity,
  renderSeverityLabel,
  resetAndClose
}) => {
  if (!open) return null;
  return (
    <div>
      <div className={styles.FilterBarModal} style={style}>
        <button
          className={styles.CloseIconButton}
          onClick={() => resetAndClose()}
          type="button"
        >
          <CloseIcon size={20} />
        </button>
        <div className={styles.FilterBarModalContent}>
          <div className={styles.severityContainer}>
            <h5 className={styles.label}>
              <a>Severity</a>
              <ServerityLabel severity={severity} />
              <span className={styles.serverityNotSelected}>
                {severity === 0 ? "Not selected" : ""}
              </span>
            </h5>
            <Slider
              dots
              min={0}
              max={5}
              step={1}
              defaultValue={0}
              value={severity}
              onChange={onSliderChange}
              trackStyle={{ backgroundColor: "#f02646" }}
              dotStyle={{ borderColor: "#a2a1a2" }}
              activeDotStyle={{ borderColor: "#f02646" }}
              handleStyle={
                severity === 0
                  ? { borderColor: "#a2a1a2" }
                  : { borderColor: "#f02646" }
              }
            />
          </div>
          <h5 className={styles.label}>Attack vectors</h5>
          <div className={styles.vectorContainer}>
            {attackVectors.map(vector => (
              <button
                key={vector}
                className={
                  vector === selectedVector ? styles.vectorOn : styles.vectorOff
                }
                onClick={() => toggleAttackVector(vector)}
                type="button"
              >
                {vector}
              </button>
            ))}
          </div>
        </div>
        <div className={styles.modalFooter}>
          <button
            className={styles.buttonClearAll}
            onClick={clearFilters}
            type="button"
          >
            Clear All
          </button>
          <button
            className={styles.buttonPrimary}
            onClick={updateFilterModal}
            type="button"
          >
            Done
          </button>
        </div>
      </div>
      <div className={styles.FilterBarModalCover} />
    </div>
  );
};

class FilterBar extends Component<Props, State> {
  state = {
    modalOpen: false,
    selectedVector: null,
    severity: 0,
    dimensions: {
      left: -1,
      top: -1
    },
    initialScrollingPos: 0
  };

  componentDidMount() {
    document.addEventListener("keydown", this.escFunction, false);

    window.setTimeout(() => {
      const initialScrollingPos = window.scrollY;
      this.setState({ initialScrollingPos });
    }, 400);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.escFunction, false);
  }

  escFunction = event => {
    if (event.keyCode === 27) {
      this.resetAndClose();
    }
  };

  attackVectors = [
    "Application Layer",
    "Brute Force",
    "Data Breach",
    "DDoS",
    "Insider Threat",
    "Malware",
    "Phising",
    "Ransomeware",
    "Subcontractor",
    "XSS"
  ];

  toggleAttackVector = vector => {
    this.setState({ selectedVector: vector });
  };

  updateFilterModal = () => {
    this.toggleModal(false);
    const { selectedVector, severity } = this.state;
    const { updateFilter } = this.props;

    updateFilter({
      selectedVector,
      severity: severity === 0 ? null : severity
    });
  };

  toggleModal = open => {
    this.mobileScrollLockBody(open);
    this.setState({ modalOpen: open });
  };

  resetAndClose = () => {
    this.resetState();
    this.toggleModal(false);
  };

  resetState = () => {
    const { selectedVector, severity } = this.props;
    this.setState({
      selectedVector,
      severity
    });
  };

  mobileScrollLockBody = open => {
    const { dimensions } = this.state;

    if (window.innerWidth > 500) {
      return;
    }

    if (document !== "undefined") {
      if (open) {
        window.scroll(0, dimensions.top - 10);
        document.documentElement.style.overflow = "hidden";
        document.body.style.overflow = "auto";
      } else {
        document.documentElement.style.overflow = "auto";
        document.body.style.overflow = "auto";
      }
    }
  };

  onSliderChange = severity => {
    this.setState({
      severity
    });
  };

  clearFilters = () => {
    this.setState({
      selectedVector: null,
      severity: 0
    });
  };

  get countFiler() {
    const { selectedVector, severity } = this.props;

    let count = 0;
    if (selectedVector) {
      count += 1;
    }
    if (severity > 0) {
      count += 1;
    }
    return count;
  }

  render() {
    const {
      modalOpen,
      selectedVector,
      severity,
      dimensions,
      initialScrollingPos
    } = this.state;
    const { top } = dimensions;
    let { left } = dimensions;
    if (typeof window !== `undefined` && window.innerWidth <= 500) {
      left = 0;
    }

    return (
      <div>
        <div className={styles.wrapper}>
          <div className={`${styles.container} ${container.default}`}>
            <div className={styles.filterBarSection}>
              <Measure
                bounds
                onResize={contentRect => {
                  this.setState({ dimensions: contentRect.bounds });
                }}
              >
                {({ measureRef }) => (
                  <div
                    ref={measureRef}
                    style={{
                      width: "100%"
                    }}
                  >
                    <button
                      className={
                        modalOpen
                          ? styles.FilterButtonOn
                          : styles.FilterButtonOff
                      }
                      onClick={() => this.toggleModal(true)}
                      type="button"
                    >
                      <SlidersIcon className={styles.icon} />
                      FILTER
                    </button>
                    {this.countFiler > 0 ? (
                      <span className={styles.numberCircle}>
                        {this.countFiler}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </Measure>
            </div>
            <div className={styles.headerSection}>
              <span>Discovered</span>
              <span>Attack Vector</span>
              <span>Severity</span>
            </div>
          </div>
        </div>
        <FilterBarModal
          key={severity}
          style={{
            left,
            top: top + 40 + initialScrollingPos
          }}
          open={modalOpen}
          attackVectors={this.attackVectors}
          toggleAttackVector={this.toggleAttackVector}
          updateFilterModal={this.updateFilterModal}
          selectedVector={selectedVector}
          onSliderChange={this.onSliderChange}
          clearFilters={this.clearFilters}
          severity={severity}
          toggleModal={this.toggleModal}
          renderSeverityLabel={this.renderSeverityLabel}
          resetAndClose={this.resetAndClose}
        />
      </div>
    );
  }
}

export default FilterBar;



// WEBPACK FOOTER //
// ./src/components/Landing/FilterBar/FilterBar.js